import { Component, Input } from '@angular/core';
import { AnimationComponent } from '../animation/animation.component';

@Component({
  selector: 'app-card-loader',
  standalone: true,
  imports: [AnimationComponent],
  template: `
    <div class="card-loader">
      <app-animation
        src="dots_loader.json"
        [autoplay]="true"
        [loop]="true"
        [style.width]="width"
      ></app-animation>
    </div>
  `,
  styles: [
    `
      .card-loader {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: auto;
        width: 100%;
      }
    `,
  ],
})
export class CardLoaderComponent {
  @Input() width = '80px';
}
